/* eslint-disable react/jsx-no-target-blank */
import {ReactNode, useEffect, useState} from 'react'
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {isCashier, isOffice, isOfficeRestricted} from 'app/utils/role'
import {Skeleton} from 'antd'
import {useUser} from 'app/hook/useUser'
import {Administrator, Cashier, Office, OfficeRestricted} from 'consts/role'
import {Menu} from 'app/core/_model'
import {useMenu} from 'json/useMenu'

export function AsideMenuMain() {
  const {user} = useUser()

  const {noRoleMenu, applicationMenu} = useMenu()

  const [menus, setMenus] = useState(noRoleMenu)
  const [loading, setLoading] = useState(true)

  const renderSkeletons = (count: number) => {
    return (
      <>
        {Array.from({length: count}).map((_, index) => (
          <Skeleton.Input key={index} active={true} className='px-8 mb-1' size={'large'} block style={{height: 30}} />
        ))}
      </>
    )
  }

  const renderMenuItem = (menus: Menu[]) => {
    const menuItems: ReactNode[] = []

    menus.forEach((menu) => {
      if (menu.children && menu.children.length > 0) {
        const submenuItems = renderMenuItem(menu.children)
        menuItems.push(
          <AsideMenuItemWithSub key={menu?.to} to={menu.to || ''} icon={menu?.icon} title={menu?.title || ''} fontIcon={menu?.fontIcon}>
            {submenuItems}
          </AsideMenuItemWithSub>
        )
      } else {
        if (menu?.divider) {
          menuItems.push(
            <div className='menu-item' key={menu?.title ?? menu?.to}>
              <div className='menu-content pt-8 pb-2'>
                <span className='menu-section text-muted text-uppercase fs-8 ls-1'>{menu?.title}</span>
              </div>
            </div>
          )
        } else {
          menuItems.push(<AsideMenuItem key={menu?.to} to={menu.to || ''} icon={menu?.icon} title={menu?.title || ''} fontIcon={menu?.fontIcon} hasBullet={menu?.hasBullet} />)
        }
      }
    })

    return menuItems
  }

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (user) {
        if (user?.is_sysadmin) {
          setMenus(applicationMenu)
        } else if (user?.is_administrator) {
          setMenus(filterMenuByRole(applicationMenu, Administrator.value))
        } else {
          if (isCashier(user)) {
            setMenus(filterMenuByRole(applicationMenu, Cashier.value))
          } else if (isOfficeRestricted(user)) {
            setMenus(filterMenuByRole(applicationMenu, OfficeRestricted.value))
          } else if (isOffice(user)) {
            setMenus(filterMenuByRole(applicationMenu, Office.value))
          }
        }
      } else {
        setMenus(noRoleMenu)
      }
      setLoading(false)
    }, 500)

    return () => clearTimeout(timeout)
  }, [])

  // const invokeRole = () => {
  //   const filteredMenu = filterMenuByRole(sysAdminMenu, 'OFFICE')
  //   console.log(sysAdminMenu)
  //   console.log('filteredMenu', filteredMenu)
  // }

  function filterMenuByRole(menu: Menu[], role: string): Menu[] {
    return menu
      .filter((item) => item.role?.includes(role) || item.role?.includes('*'))
      .map((item) => ({
        ...item,
        children: item.children ? filterMenuByRole(item.children, role) : undefined,
      }))
      .filter((item) => item.children?.length || !item.children)
  }

  return (
    <>
      {
        loading ? renderSkeletons(5) : renderMenuItem(menus)
        // <>
        //   <AsideMenuItem to='/dashboard' icon='/media/icons/duotune/art/art002.svg' title='Beranda' fontIcon='bi-app-indicator' />
        //   <AsideMenuItemWithSub to='/master' title='Master' fontIcon='bi-archive' icon='/media/icons/duotune/general/gen025.svg'>
        //     {(user?.is_administrator || user?.is_sysadmin) && <AsideMenuItem to='/master/bank' title='Bank' hasBullet={true} />}
        //     {!isCashier(user!) && <AsideMenuItem to='/master/barang' title='Barang' hasBullet={true} />}
        //     {(user?.is_administrator || user?.is_sysadmin) && <AsideMenuItem to='/master/product-category' title='Kategori Barang' hasBullet={true} />}
        //     <AsideMenuItem to='/master/customer' title='Pelanggan' hasBullet={true} />
        //     {user?.is_administrator && <AsideMenuItem to='/master/uom' title='Satuan' hasBullet={true} />}
        //     {(user?.is_administrator || user?.is_sysadmin) && <AsideMenuItem to='/master/colour' title='Warna' hasBullet={true} />}
        //   </AsideMenuItemWithSub>
        //   {user && (user?.is_administrator || user?.is_sysadmin || isCashier(user!) || isOffice(user!)) && (
        //     <AsideMenuItemWithSub to='/transaction' title='Transaksi' fontIcon='bi-archive' icon='/media/icons/duotune/general/gen025.svg'>
        //       {!isOffice(user!) && <AsideMenuItem to='/transaction/sales' title='Transaksi Penjualan' hasBullet={true} />}
        //       {!isCashier(user!) && <AsideMenuItem to='/transaction/product/incoming' title='Barang Masuk/Terima dari Cabang' hasBullet={true} />}
        //       {!isOffice(user!) && <AsideMenuItem to='/transaction/product/outgoing' title='Barang Keluar/Retur ke Cabang/Extra' hasBullet={true} />}
        //     </AsideMenuItemWithSub>
        //   )}
        //   {(user?.is_administrator || user?.is_sysadmin) && (
        //     <>
        // <div className='menu-item'>
        //   <div className='menu-content pt-8 pb-2'>
        //     <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Management</span>
        //   </div>
        // </div>
        //     </>
        //   )}
        //   {user?.is_sysadmin && (
        //     <>
        //       <AsideMenuItem to='/settings/area' icon='/media/icons/duotune/general/gen051.svg' title='Wilayah' fontIcon='bi-layers' />
        //       <AsideMenuItem to='/settings/store' icon='/media/icons/duotune/finance/fin001.svg' title='Store' fontIcon='bi-layers' />
        //     </>
        //   )}
        //   {(user?.is_administrator || user?.is_sysadmin) && (
        //     <AsideMenuItem to='/settings/user-management' icon='/media/icons/duotune/general/gen051.svg' title='User Management' fontIcon='bi-layers' />
        //   )}
        // </>
      }

      {/**/}

      {/*  */}

      {/* <AsideMenuItem to='/apps/user-management/users' icon='/media/icons/duotune/general/gen051.svg' title='User management' fontIcon='bi-layers' /> */}

      {/* <div className='menu-item'>
        <a target='_blank' className='menu-link' href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}>
          <span className='menu-icon'>
            <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}
